export default __webpack_public_path__ + "static/media/1215.5dae49fd.png";